import Service from "../Service";

const contact = {
  saveContact(data) {
    return Service.post("api/contact", data).then((res) => res);
  },
  getImageLanding(data) {
    return Service.post("api/contact", data).then((res) => res);
  },
};

export default contact;
